import { TimelineScrubber } from '@/components/timeline-scrubber';
import { useExternalOis } from '@/lib/api/queries';
import { isImageryBasemap } from '@/lib/map/basemaps';
import { useOiStore } from '@/lib/store/oi';
import { useUiStore } from '@/lib/store/ui';
import { useEffect, useMemo, useState } from 'react';
import { SCRUBBER_HOURS, buildHourBuckets } from './oiFilter';
import { useNow } from './useNow';

/** ENG-184 scrubber docked over the bottom of the map — 3rd Party only
 *  (ENG-188). Clear of the layer button (bottom-left) and zoom buttons
 *  (bottom-right). */
export function ExternalTimeline() {
  const ctx = useUiStore((s) => s.activeContext);
  const category = useOiStore((s) => s.category);
  if (ctx !== 'oi' || category !== '3rdparty') return null;
  return <ExternalTimelineBar />;
}

function ExternalTimelineBar() {
  const { data } = useExternalOis();
  const setSelectedHour = useOiStore((s) => s.setSelectedHour);
  const onImagery = useUiStore((s) => isImageryBasemap(s.basemap));
  const now = useNow();
  const buckets = useMemo(() => buildHourBuckets(data ?? [], now), [data, now]);
  // The scrubber owns its selection after mount; start it where the store is
  // (no bar selected unless the user picked an hour earlier) and keep the
  // store in step.
  const [initialIndex] = useState(() => useOiStore.getState().selectedHour);
  useEffect(() => {
    setSelectedHour(initialIndex);
  }, [initialIndex, setSelectedHour]);

  return (
    // No panel behind it: the scrubber's hover reveal zone is tall, and the
    // component is designed to float over the map (its story is transparent).
    <div className="absolute bottom-[calc(0.75rem+var(--map-inset,0px))] left-14 right-14 z-10">
      <TimelineScrubber
        buckets={buckets}
        durationHours={SCRUBBER_HOURS}
        defaultSelectedIndex={initialIndex}
        surface={onImagery ? 'imagery' : 'default'}
        onSelect={(bucket) => setSelectedHour(bucket?.offsetHours ?? null)}
      />
    </div>
  );
}
